export default __webpack_public_path__ + "static/media/Eye_3_M_C3.eece2811.svg";